import type { Announcement } from '../types';

export const a_2026_07_07: Announcement = {
  id: '2026-07-07-droit-administratif',
  date: '2026-07-07',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 7 juillet 2026',
  title: "Hector s'améliore : le droit administratif fait son entrée",
  navLabel: 'Droit administratif',
  subtitle: '',
  sections: [
    {
      label: '',
      features: [
        {
          id: 'jurisprudence-administrative',
          title: 'Recherche de jurisprudence administrative',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Recherchez et consultez les décisions des tribunaux administratifs, des cours administratives d'appel et du Conseil d'État, aux côtés de la jurisprudence judiciaire.",
            ],
          },
        },
        {
          id: 'actes-droit-public',
          title: 'Rédaction des actes de droit administratif',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "La spécialisation « Droit Public » est ouverte à tous dans l'add-in Word. Requêtes, mémoires et référés administratifs sont disponibles à la génération, avec un raisonnement adapté à la matière : date d'appréciation de la légalité, causes juridiques, délais de recours.",
            ],
          },
        },
        {
          id: 'bordereau-telerecours',
          title: 'Bordereaux au format Télérecours',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Générez des bordereaux de communication de pièces conformes au formalisme Télérecours, directement exploitables pour le dépôt.",
            ],
          },
        },
      ],
    },
  ],
};
